import TabTemplate from "components/shared/profile/tab";
import React from "react";
import LogistTaskSettings from "./logistTaskSettings";

export default class TaskSettingsTab extends TabTemplate {
    renderBody = () => {
        const { editable, profile, roles } = this.props;
        return <LogistTaskSettings editable={editable} profile={profile} roles={roles} />;
    };
}
